import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@mui/material';

function SalesActionStatTable({ filteredEvents = [], onRowClick }) {
  console.log(filteredEvents);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  React.useEffect(() => {
    setPage(0);
  }, [filteredEvents]);

  const pagedEvents = React.useMemo(() => {
    return filteredEvents.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [filteredEvents, page, rowsPerPage]);

  return (
    <Paper 
      elevation={0}
      sx={{ 
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)', 
        borderRadius: '12px',
        border: '1px solid rgba(0, 0, 0, 0.03)',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        mt: -0.5
      }}
    >
      <TableContainer sx={{ height: 290, overflowY: 'auto' }}>
        <Table stickyHeader sx={{ minWidth: 750 }} size="small" aria-label="sales action stat detailed table">
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ fontWeight: '600', color: '#4B5563', py: 1, pl: 3, backgroundColor: '#F9FAFB', width: '16%', fontSize: '13px' }}>업무구분</TableCell>
              <TableCell align="center" sx={{ fontWeight: '600', color: '#4B5563', py: 1, backgroundColor: '#F9FAFB', width: '16%', fontSize: '13px' }}>일시</TableCell>
              <TableCell align="center" sx={{ fontWeight: '600', color: '#4B5563', py: 1, backgroundColor: '#F9FAFB', width: '16%', fontSize: '13px' }}>업체</TableCell>
              <TableCell align="center" sx={{ fontWeight: '600', color: '#4B5563', py: 1, backgroundColor: '#F9FAFB', width: '10%', fontSize: '13px' }}>업체 유형</TableCell>
              <TableCell align="center" sx={{ fontWeight: '600', color: '#4B5563', py: 1, backgroundColor: '#F9FAFB', width: '10%', fontSize: '13px' }}>장소</TableCell>
              <TableCell align="center" sx={{ fontWeight: '600', color: '#4B5563', py: 1, backgroundColor: '#F9FAFB', width: '24%', fontSize: '13px' }}>제목</TableCell>
              <TableCell align="center" sx={{ fontWeight: '600', color: '#4B5563', py: 1, backgroundColor: '#F9FAFB', width: '8%', fontSize: '13px' }}>담당자명</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pagedEvents.length > 0 ? (
              pagedEvents.map((row, index) => (
                <TableRow 
                  key={row.actionId || row.actionCode || index}
                  hover
                  onClick={() => onRowClick && onRowClick(row)}
                  sx={{ 
                    height: 34, 
                    cursor: onRowClick ? 'pointer' : 'default',
                    '&:last-child td, &:last-child th': { border: 0 }, 
                    '&:hover': { backgroundColor: '#F9FAFB' } 
                  }}
                >
                  <TableCell align="left" sx={{ pl: 3, fontWeight: '500', color: '#374151', py: 0.5, fontSize: '13px', wordBreak: 'break-all' }}>
                    {row.actionName || '-'}
                  </TableCell>
                  <TableCell align="center" sx={{ color: '#374151', py: 0.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '13px' }}>
                    {row.startDatetime && row.endDatetime ? `${row.startDatetime.substring(0, 16)} ~ ${row.endDatetime.substring(11, 16)}` : row.totalTime || '-'}
                  </TableCell>
                  <TableCell align="center" sx={{ color: '#374151', py: 0.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '13px' }}>
                    {row.companyNm || '-'}
                  </TableCell>
                  <TableCell align="center" sx={{ color: '#374151', py: 0.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '13px' }}>
                    {row.partnerTyp || '-'}
                  </TableCell>
                  <TableCell align="center" sx={{ color: '#374151', py: 0.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '13px' }}>
                    {row.meetPlace || '-'}
                  </TableCell>
                  <TableCell align="center" sx={{ color: '#374151', py: 0.5, fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '13px' }}>
                    {row.title || '-'}
                  </TableCell>
                  <TableCell align="center" sx={{ color: '#374151', py: 0.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '13px' }}>
                    {row.usrNm || '-'}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow style={{ height: 240 }}>
                <TableCell colSpan={6} align="center" sx={{ color: 'text.secondary', fontSize: '13px' }}>
                  조회된 통계 데이터가 없습니다.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={filteredEvents.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="페이지당 행 수:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} / 전체 ${count}개`}
        sx={{ borderTop: '1px solid #f3f4f6', backgroundColor: '#ffffff', '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select': { fontSize: '12px' } }}
      />
    </Paper>
  );
}

export default SalesActionStatTable;
